export default "__VITE_PUBLIC_ASSET__779ae7ab__"